import SecundButton from 'components/form/buttons/secundButton';

// import { useActions } from "common/hooks/useActions";
import MiniPopUp from 'components/modal/miniPopUp';
import PanelBoxLayout from 'components/layout/panelBox';

import { Formik } from 'formik';
import Gap from 'components/gap';
import PrimaryButton from 'components/form/buttons/primaryButton';
import { SetStateAction } from 'react';

import * as S from './styles';
import * as T from 'common/types';
import DropDown from 'components/form/dropDown';
import OutlineButton from 'components/form/buttons/outLineButton';

interface IProps {
  setFilter: SetStateAction<any>;
  setPage: SetStateAction<any>;
  filter: any;
}

export default function TicketFilterPopup({ setFilter, filter, setPage }: IProps) {
  return (
    <S.Content>
      <MiniPopUp
        popUpStyle={{ width: 280, padding: '0' }}
        buttonNode={
          <SecundButton
            hasIcon={true}
            icon="/icons/stroke/filter.svg"
            iconStyle={{ background: 'none' }}
            className="secondary"
          >
            Filters
          </SecundButton>
        }
      >
        <PanelBoxLayout className="bare" title="Filters" icon="/icons/stroke/filter.svg">
          <Formik
            initialValues={{
              status: ''
            }}
            // validationSchema={ValidationLogin}
            onSubmit={(values, { setSubmitting }) => {
              setFilter({ ...filter, ...values });
              setSubmitting(false);
              setPage(1);
            }}
          >
            {({
              values,
              errors,
              touched,
              // handleChange,
              handleSubmit,
              // isSubmitting,
              setValues,
              resetForm
            }) => (
              <>
                <DropDown
                  label="Status"
                  list={[
                    { id: 'NEW', title: 'New' },
                    { id: 'IN_PROGRESS', title: 'In Progress' },
                    { id: 'CLOSED_BY_ADMIN', title: 'Closed by admin' },
                    { id: 'CLOSED_BY_USER', title: 'Closed by user' }
                  ]}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      status: e.id as any
                    });
                  }}
                  placeholder="Select Status"
                  message={touched.status && (errors.status as any)}
                  error={errors.status as unknown as boolean}
                />
                {/* <Gap size="20px" />

                <DropDown
                  label="Categories"
                  list={ticketCategory}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      categoryId: e.id as any
                    });
                  }}
                  placeholder="Select Categories"
                  message={touched.categoryId && (errors.categoryId as any)}
                  error={errors.categoryId as unknown as boolean}
                /> */}

                <Gap size="20px" />

                <PrimaryButton
                  onClick={handleSubmit}
                  // disabled={isSubmitting}
                  style={{ width: '100%' }}
                >
                  Filter
                </PrimaryButton>
                <Gap size="15px" />
                <OutlineButton
                  onClick={() => {
                    resetForm();
                    setPage(1);
                    setFilter({ status: '' });
                  }}
                  // disabled={isSubmitting}
                  style={{ width: '100%' }}
                >
                  Reset
                </OutlineButton>
              </>
            )}
          </Formik>
        </PanelBoxLayout>
      </MiniPopUp>
    </S.Content>
  );
}
